/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/message/custom-elements';

import { defineCustomElement as defineOsdsMessage } from '@ovhcloud/ods-stencil/components/message/custom-elements/osds-message.js';


export const OsdsMessage = /*@__PURE__*/ defineContainer<JSX.OsdsMessage>('osds-message', defineOsdsMessage, [
  'color',
  'flex',
  'icon',
  'removable',
  'type',
  'contrasted',
  'odsRemoveClick'
]);

